<template>
  <div class="animated fadeIn">
    <default-heading text="Add Customer Coord Results" class="mt-3">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          to="/customer-coords"
        >
          <i class="fal fa-list" />
        </b-button>
      </template>
    </default-heading>

    <div class="mb-3">
      <CustomerCoordForm :submittingForm="submittingForm" :error="error" @submit="submit" />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import CustomerCoordForm from '@/components/crm/customer/CustomerCoordForm'
import CustomerCoordModel from '@/models/crm/CustomerCoordModel'

export default {
  name: 'CustomerCoordAdd',
  components: {
    DefaultHeading,
    CustomerCoordForm
  },
  data () {
    return {
      error: null,
      submittingForm: false,
      customer_id: this.$store.getters.getAuthCustomerID,
    }
  },
  methods: {
    async submit (form_data) {
      this.error = null
      this.submittingForm = true

      try {
        const customerCoordModel = new CustomerCoordModel({
          ...form_data,
          customer_id: this.customer_id
        })

        const { response } = await customerCoordModel.save()

        this.$bvToast.toast('Customer Coord', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.$router.push('/customer-coords')
      } catch (err) {
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please contact an administrator'
        }
      }

      this.submittingForm = false
    }
  }
}
</script>
